var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass(),attrs:{"type":"button","id":_vm.inputButton.id},on:{"click":function($event){_vm.$emit('changeButton', _vm.inputButton.value)}}},[_c('span',[_vm._v(_vm._s(_vm.inputButton.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }